export default __webpack_public_path__ + "static/media/3.95478fd0.jpg";